import React from "react";
import { useNavigate } from "react-router-dom";
import { useState } from "react";
import SignUp from "./SignUp";

function Login({userEmails}){
  const [signIn,SetSign]=useState({
    email:"",
    password:""
  })
  const navitage=useNavigate()
function handleClick(){
  console.log("clicked");
  navitage('/signup')

}
function handleChange(event){
  const { name, value } = event.target;
        SetSign((prevForm) => ({ ...prevForm, [name]: value }));
}
function handleClick2() {
  console.log("Form", signIn);
  const isEmailExists = userEmails.includes(signIn.email);
  if (isEmailExists) {
    navitage("/home");
  } else {
    alert('Invalid Email or Password');
  }
}
 return(
    <>
    <div className="cont">
      <div className="form sign-in">
        <h2>Welcome back,</h2>
        <label>
          <span>Email</span>
          <input type="email" name="email" value={signIn.email} onChange={handleChange} />
        </label>
        <label>
          <span>Password</span>
          <input type="password" name="password" value={signIn.password} onChange={handleChange}/>
        </label>
        <p className="forgot-pass">Forgot password?</p>
        <button type="button" className="submit" onClick={handleClick2}>Sign In</button>
        <button type="button" className="fb-btn">Connect with <span>facebook</span></button>
      </div>
      <div className="sub-cont">
        <div className="img">
          <div className="img__text m--up">
            <h2>New here?</h2>
            <p>Sign up and discover great amount of new opportunities!</p>
          </div>
          <div className="img__text m--in">
            <h2>One of us?</h2>
            <p>If you already has an account, just sign in. We've missed you!</p>
          </div>
          <div className="img__btn"  onClick={handleClick}>
            <span className="m--up">Sign Up</span>
            <span className="m--in">Sign In</span>
          </div>
        </div>
        <div className="form sign-up">
          <h2>Time to feel like home,</h2>
          <label>
            <span>Name</span>
            <input type="text" />
          </label>
          <label>
            <span>Email</span>
            <input type="email" />
          </label>
          <label>
            <span>Password</span>
            <input type="password" />
          </label>
          <button type="button" className="submit" >Sign Up</button>
          <button type="button" className="fb-btn">Join with <span>facebook</span></button>
        </div>
      </div>
    </div>
    </>
 )
}
export default Login